import { useEffect, useState } from "react";
import { GetActiveEdTeams, GetEdTeams } from "../Shared/Services";
import { Button, Col, Row, Tooltip } from "antd";
import { EditOutlined, ExportOutlined, PlusOutlined, SwapOutlined } from "@ant-design/icons";
import PediPlayPageHeader from "../Shared/UI/PediplayPageHeader";
import ETTable from "./ETTable";
import ETForm from "./Form";
import { iconSize } from "../Shared/UI/jsx";
import { disciplineTransform, exportToCSV } from "../Shared/Functions";

const EdTeams = props => {
    const [data, setData] = useState();
    const [highlighted, setHighlighted] = useState();
    const [loading, setLoading] = useState(true);
    const [formType, setFormType] = useState();
    const [visibility, setVisibility] = useState(false);
    const [activeOnly, setActiveOnly] = useState(true);

    useEffect(() => {
        if(activeOnly) {
            GetActiveEdTeams()
                .then((res) => {
                    setData(res.data);
                    setHighlighted(res.data[0]);
                })
                .finally(() => {
                    setLoading(false);
                })
        } else {
            GetEdTeams()
                .then((res) => {
                    setData(res.data);
                    setHighlighted(res.data[0]);
                })
                .finally(() => {
                    setLoading(false);
                })
        }
    }, [activeOnly]);

    const handleEdit = () => {
        setFormType('edit');
        setVisibility(true);
    }

    const handleCreate = () => {
        setFormType('create');
        setVisibility(true);
    }

    const handleAfterFormSubmit = record => {
        setLoading(true);
        setData([record]);
        setHighlighted(record);
        setLoading(false);
    }

    const handleRowOnClick = record => {
        setHighlighted(record);
    }

    const handleActiveOnly = () => {
        setActiveOnly(!activeOnly);
    }

    const extra = (
        <div style={{ textAlign: 'end' }}>
            <Tooltip title="Add" placement="top">
                <Button
                    type="link"
                    icon={<PlusOutlined style={iconSize} />}
                    onClick={() => handleCreate()}
                />
            </Tooltip>
            <Tooltip title="Edit" placement="top">
                <Button 
                    type="link"
                    icon={<EditOutlined style={iconSize} />}
                    onClick={() => handleEdit()}
                />
            </Tooltip>
            <Tooltip title="Export" placement='top'>
                <Button
                    type='link'
                    icon={<ExportOutlined style={iconSize} />}
                    onClick={() => exportToCSV("ServiceCoordinators.csv", data, {
                        exclude: ["id"],
                        transforms: {
                            spoe: v => (v === 0 ? "J" : v === 1 ? "G" : v),
                            discipline: disciplineTransform
                        }
                    })}
                />     
            </Tooltip>
            <Tooltip title={activeOnly ? "Show All" : "Show Active Only"} placement='top'>
                <Button
                    type="link"
                    icon={<SwapOutlined style={iconSize} />}
                    onClick={() => handleActiveOnly()}
                />    
            </Tooltip>
            <ETForm
                formType={formType}
                setFormType={setFormType}
                visibility={visibility}
                setVisibility={setVisibility}
                highlighted={highlighted}
                handleAfterFormSubmit={handleAfterFormSubmit}
            />
        </div>
    );

    return (
        <div>
            <Row gutter={[8,8]}>
                <Col span={24}>
                    <PediPlayPageHeader
                        title={'Ed Teams'}
                        props={props}
                        extra={extra}
                        loading={loading}
                    />    
                </Col>
                <Col span={24}>
                    <ETTable loading={loading} highlighted={highlighted} edTeams={data} handleRowOnClick={handleRowOnClick}/>
                </Col>
            </Row>
        </div>
    )

}

export default EdTeams;